<template>
  <div class="w98">
   <div class="crumb">
      <span><router-link to="/Help">帮助</router-link>  > </span>
      <span>用户注册与登录</span>
    </div>
     <help-Menu></help-Menu>
    <div class="rightContent">
      <div class="conten">
            <p class="text">打开网络浏览器，在地址栏输入相应地址，按回车键进入到本软件的登录界面（默认选中“远程教学系统”）。</p>
            <div><img src="../../../../static/image/login.png"/></div>
            <p class="text">在上图中输入正确的手机号、密码、验证码，点击“登录”按钮。登录成功后，页面跳转到远程医学影像教育系统默认首页。</p>
      </div>
    </div>
</div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  import helpMenu from '@/components/common/helpMenu/helpMenu'
  export default {
    data () {
      return {
         height:''
      }
    },
    components:{
        helpHead,
        helpMenu
    },
      mounted() {
      setTimeout(() => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      }, 20)
      window.addEventListener('resize', () => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      })
    },
}

</script>


<style scoped lang="stylus" rel="stylesheet/stylus">
.content
    min-width: 100vw
    height: 100vh
    overflow: hidden
  .rightContent
    position: relative
    float: right
    height :calc(100vh - 80px)
    width: calc(80% - 1px)
    min-width: 919px
    background :#fff
   .conten
      padding: 25px 25px 25px 30px

   .text
     color:#555
     line-height: 25px
     text-indent:2em
     margin-bottom:15px
 .crumb
 line-height: 30px
 margin: 5px 0 0 20px
</style>



// WEBPACK FOOTER //
// UserMessage.vue?027605b3